// Import the functions you need from the SDKs you need
import { ENV } from "@Constants/config";
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDzAE4L36jTDFNdzh335hE2uzJw0WvVfY8",
    authDomain: "lp-inbox-stage.firebaseapp.com",
    projectId: "lp-inbox-stage",
    storageBucket: "lp-inbox-stage.firebasestorage.app",
    messagingSenderId: "910884679565",
    appId: "1:910884679565:web:80e6d750aea7c63cb057c4",
    measurementId: "G-D5KY7DRHFN"
};

const app = initializeApp(firebaseConfig);

// Determine Database ID based on environment
const databaseId = ENV === "prod" ? "prod-inbox" : "stage-inbox";

// Export firestore database
// It will be imported into your react app whenever it is needed
export const db = getFirestore(app, databaseId);
export const auth = getAuth(app);